import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import CurrencyTextBoxViewModelType from '@/ViewModels/Controls/CurrencyTextBoxViewModel';
import NumericTextBoxType from '@/Controls/NumericTextBox';
import DropDownListType from '@/Controls/DropDownList';

export default class CurrencyTextBox extends Control {

    private NumericTextBox = ComponentManager.getControl<typeof NumericTextBoxType>('NumericTextBox');
    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private jQueryControl: JQuery;
    private dropDownList: DropDownListType;
    private numericTextBox: NumericTextBoxType;

    public constructor(private viewModel: CurrencyTextBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'currencytextbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,
            
            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.numericTextBox != null) {
            this.viewModel.invalidationText.sync(this.viewModel.numericTextBox.invalidationText);
            this.viewModel.isValid.sync(this.viewModel.numericTextBox.isValid);
            this.numericTextBox = new this.NumericTextBox(this.viewModel.numericTextBox);
            let tuple = this.numericTextBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.dropDownList != null) {
            this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
            let tuple = this.dropDownList.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        this.numericTextBox.addLabelReference(label);
        return label;
    }
}

ComponentManager.setControl('CurrencyTextBox', CurrencyTextBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');